import { render } from "./Header.vue?vue&type=template&id=3469de12"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
script.render = render

export default script